<div class="doc" [class.exc]="decision === 'exc'" [class.pend]="decision === 'pend'" [class.sel]="selected" [attr.data-doc]="doc.id">
  <input type="checkbox" class="doc-select" [checked]="selected" (change)="onSelect($any($event.target).checked)" [attr.aria-label]="'Select ' + doc.name">
  <df-file-badge [ext]="doc.ext"></df-file-badge>
  <div style="min-width:0">
    <button type="button" class="d-name" [title]="doc.name" (click)="open()">{{ doc.name }}</button>
    <div class="d-meta">
      <span class="pill" [ngClass]="df.coverageLandscape(doc)">{{ landscapeLabel(df.coverageLandscape(doc)) }}</span>
      <span *ngIf="doc.l2.length">{{ doc.l2.join(', ') }}</span>
      <span>{{ lastFolder }}</span>
      <span *ngIf="doc.version">v{{ doc.version }}</span>
    </div>
    <div class="d-dup" *ngIf="doc.copies?.length">
      <df-icon name="pack" [size]="12"></df-icon>
      <span>{{ doc.copies!.length }} duplicate{{ doc.copies!.length > 1 ? 's' : '' }} removed — this is the copy kept</span>
    </div>
    <div class="d-dup warn" *ngIf="doc.alternates?.length">
      <df-icon name="pack" [size]="12"></df-icon>
      <span><b>Pick the version:</b> {{ doc.alternates!.length + 1 }} candidates, none provably latest (open for details)</span>
    </div>
    <!-- <div class="d-dup warn" *ngIf="doc.versionUnclear && !doc.alternates?.length">
      <df-icon name="hist" [size]="12"></df-icon><span>Version unclear — open for details</span>
    </div> -->
  </div>
  <div>
    <div class="decide" role="group" [attr.aria-label]="'Decision for ' + doc.name">
      <button type="button" class="dz inc" [attr.aria-pressed]="decision === 'inc'" (click)="include()"><df-icon name="check" [size]="13"></df-icon>Relevant</button>
      <button type="button" class="dz exc" [attr.aria-pressed]="decision === 'exc'" (click)="exclude()"><df-icon name="x" [size]="13"></df-icon>Irrelevant</button>
    </div>
    <div class="reason" *ngIf="decision === 'exc' && reason">{{ reason }}<ng-container *ngIf="byAgent"> · by agent</ng-container></div>
    <div class="reason" *ngIf="decision === 'pend'" style="color:#7A4B00">Needs your decision</div>
  </div>
</div>